module.exports = __webpack_public_path__ + "media/images/communities/logos/ao14-eda3d74ef16c0cd6d6dd4f1c524409ab.png";